import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import * as signalR from '@microsoft/signalr';
import { fetchCompanyBranding } from '../api/settingsApi';

const HUB_URL = `${import.meta.env.VITE_API_URL}/hub/liverefresh`;

export default function useCompanyBranding() {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ['companyBranding'],
        queryFn:  fetchCompanyBranding,
    });

    useEffect(() => {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(HUB_URL, {
                accessTokenFactory: () =>
                    window.Clerk.session.getToken({ template: 'marginpal-api' }),
            })
            .withAutomaticReconnect()
            .build();

        connection.on('UpdateBranding', () => {
            queryClient.invalidateQueries({ queryKey: ['companyBranding'] });
        });

        connection.start().catch(err => console.error('SignalR connection error:', err));

        return () => {
            connection.stop();
        };
    }, [queryClient]);

    return query;
}
